import { TooltipContainer } from "@outplayed/tooltips";
import classNames from "classnames";
import { useRef } from "react";

interface LaneSelectProps {
  disableTooltip?: boolean;
  options: { [key: string]: string }[];
  onFilterChange: (type: string, value: string) => void;
  value: any;
}

const LaneSplit = (props: LaneSelectProps) => {
  const { disableTooltip, options, onFilterChange, value } = props;
  const tooltipRef = useRef<{ forceClose: Function }>({ forceClose: () => {} });

  const displayLaneFilters = () => {
    return options.map((option) => {
      const isSelectedLane = option.value === value;

      const selectorClassNames = classNames("role-filter", {
        active: isSelectedLane,
      });

      return (
        <TooltipContainer key={option.value} ref={tooltipRef} tooltipInfo={"Change Lane Type"} disableTooltip={disableTooltip}>
          <div className={selectorClassNames} onClick={() => onFilterChange("lane", option.value)}>
            {option.label}
          </div>
        </TooltipContainer>
      );
    });
  };

  return <div className={classNames("role-filter-container")}>{displayLaneFilters()}</div>;
};

export default LaneSplit;
